import React, { FC, useEffect } from "react"
import { SingleLineTextInput } from "dash-styled"

import { useFloat } from "../../../../../../../../../../../../Hooks/useFloat"

interface LabelerPaymentProps {
    label: string
    className?: string
    value: number | undefined
    onChange: (value: number | undefined) => void
}

export const LabelerPayment: FC<LabelerPaymentProps> = ({
    label,
    className,
    value,
    onChange
}) => {
    const [float, displayValue, , setNumberFromInputChangeEvent] =
        useFloat(value)

    useEffect(() => {
        if ("" + float === displayValue && float !== value) {
            onChange(float)
        }
    }, [float, value, onChange, displayValue])

    return (
        <div
            className={`flex items-center ${className ?? ""}`}
            data-testid="labeler-payment"
        >
            <span data-testid="task-name">{label}</span>
            <SingleLineTextInput
                size="sm"
                className="ml-1 w-20"
                testId="task-payment-input"
                type="number"
                transparentBg={true}
                value={displayValue}
                onChange={setNumberFromInputChangeEvent}
            />
        </div>
    )
}
